(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mp-anchor-link"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    var anchor = event.target.closest('[data-mp-anchor-link]');
    if (!anchor) return;

    var targetId = anchor.getAttribute('data-mp-anchor-link');
    var targetEl = document.getElementById(targetId)
      || document.getElementById('shopify-section-' + targetId);

    if (targetEl) {
      event.preventDefault();
      var offset = parseInt(anchor.getAttribute('data-mp-anchor-offset'), 10) || 0;
      var top = targetEl.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mp-pdp-links-row"] && !Shopify.designMode) return;
  try {
    (function () {
    /* `scrollend` is not available in every browser yet, so a timer backs it up. */
    var SETTLE_TIMEOUT = 700;
    var CORRECTION_PASSES = 2;

    /**
     * Runs `callback` once the page has stopped scrolling — unless the visitor
     * takes the scroll over first, since a correction that fights their input
     * would feel broken.
     * @param {() => void} callback
     */
    function afterScroll(callback) {
      var controller = new AbortController();
      var options = { signal: controller.signal, once: true, passive: true };
      var timer = setTimeout(finish, SETTLE_TIMEOUT);

      function finish() {
        clearTimeout(timer);
        controller.abort();
        callback();
      }

      function cancel() {
        clearTimeout(timer);
        controller.abort();
      }

      window.addEventListener('scrollend', finish, options);
      window.addEventListener('wheel', cancel, options);
      window.addEventListener('touchstart', cancel, options);
      window.addEventListener('keydown', cancel, options);
    }

    /**
     * Brings `targetEl` to `offset` below the top of the viewport, re-measuring
     * once the scroll settles: the product details column is sticky on desktop,
     * so the target drifts while the page moves and a single measurement lands
     * short. A pass that fails to move the page ends the correction — inside a
     * pinned column the target can be out of reach, and the loop must not spin
     * on it.
     * @param {HTMLElement} targetEl
     * @param {number} offset
     * @param {number} passes
     */
    function scrollToTarget(targetEl, offset, passes) {
      var delta = targetEl.getBoundingClientRect().top - offset;
      if (Math.abs(delta) < 2) return;

      var from = window.scrollY;
      window.scrollTo({ top: from + delta, behavior: 'smooth' });
      if (passes <= 0) return;

      afterScroll(function () {
        if (Math.abs(window.scrollY - from) < 2) return;
        scrollToTarget(targetEl, offset, passes - 1);
      });
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-mp-scroll-to]');
      if (!link) return;

      var targetId = link.getAttribute('data-mp-scroll-to');
      var targetEl =
        document.getElementById(targetId) || document.getElementById('shopify-section-' + targetId);
      if (!targetEl) return;

      event.preventDefault();

      /* When the target is an accordion row — accordion-custom wraps the
         details — or sits inside one, reading it means opening it. A section
         that merely happens to contain accordion rows is left alone. Ancestors
         are walked outwards so a nested row opens together with the one holding
         it, and everything opens before the position is read: a row opening
         above the target would move it. `open` is set instead of clicking the
         summary, which keeps the theme's open animation out of the way — it
         only runs on :focus-within — so the layout is settled when measured. */
      var details = targetEl.closest('details') || targetEl.querySelector(':scope > details');
      while (details) {
        details.open = true;
        details = details.parentElement ? details.parentElement.closest('details') : null;
      }

      var offset = parseInt(link.getAttribute('data-mp-scroll-offset'), 10) || 0;
      scrollToTarget(targetEl, offset, CORRECTION_PASSES);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
